import React from 'react';
import { LanguageSwitcher } from './LanguageSwitcher';

export default function PublicLanguageDock() {
  return (
    <div className="fixed right-3 top-3 z-40 sm:right-5 sm:top-5">
      <LanguageSwitcher variant="public" />
    </div>
  );
}